"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";
import { useTranslation } from "@/lib/hooks/useTranslation";
export function OfflineBanner() {
  const $ = _c(5);
  const {
    locale
  } = useTranslation();
  const [online, setOnline] = useState(true);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      if (typeof navigator === "undefined") {
        return;
      }
      setOnline(navigator.onLine);
      const handleOnline = () => setOnline(true);
      const handleOffline = () => setOnline(false);
      window.addEventListener("online", handleOnline);
      window.addEventListener("offline", handleOffline);
      return () => {
        window.removeEventListener("online", handleOnline);
        window.removeEventListener("offline", handleOffline);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  if (online) {
    return null;
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <WifiOff className="h-3.5 w-3.5 shrink-0" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = locale === "fr" ? "Connexion perdue \u2014 tes actions peuvent ne pas \xEAtre enregistr\xE9es." : "You're offline \u2014 your actions may not be saved.";
  let t4;
  if ($[3] !== t3) {
    t4 = <div className="flex items-center justify-center gap-2 bg-yellow-500/15 px-4 py-2 text-[13px] text-yellow-200 border-b border-yellow-500/30">{t2}<span>{t3}</span></div>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}